/**
 * Raisons de suppressions d'un message
 */
export class RaisonSuppression {
    /**
     * Constructeur de la raison de la suppression
     * @param raisonObj à construire
     */
    constructor(raisonObject) {
        if (raisonObject) {
            const { idRaison, motif, rubrique } = raisonObject;
            this.idRaison = idRaison;
            this.motif = motif;
            this.rubrique = rubrique;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idRaison: this.idRaison,
            motif: this.motif,
            rubrique: this.rubrique,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFpc29uU3VwcHJlc3Npb24uY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJSYWlzb25TdXBwcmVzc2lvbi5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVILE1BQU0sT0FBTyxpQkFBaUI7SUFnQjdCOzs7T0FHRztJQUNILFlBQW1CLFlBQXlDO1FBQzNELElBQUksWUFBWSxFQUFFO1lBQ2pCLE1BQU0sRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxHQUFHLFlBQVksQ0FBQztZQUVuRCxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztZQUN6QixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztZQUNuQixJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztTQUN6QjtJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxLQUFLO1FBQ1gsT0FBTztZQUNOLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRO1NBQ3ZCLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==